export default function DownloadIcon({ color = "#7F869B", size = 14 }: { color?: string; size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 10.114V11.5257C1 11.9002 1.15804 12.2592 1.43934 12.524C1.72064 12.7888 2.10218 12.9375 2.5 12.9375H11.5C11.8978 12.9375 12.2794 12.7888 12.5607 12.524C12.842 12.2592 13 11.9002 13 11.5257V10.114"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.25 5.87868L7 9.40809L10.75 5.87868"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M7 0.9375V9.40809" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
